import type { AuditTranslations } from "../interfaces/audit";

export const auditTranslations: AuditTranslations = {
  page_title: "Auditoría",
  page_subtitle: "Consulta y filtra los registros de auditoría por flujo, acción y fechas.",
  button_refresh: "Actualizar",
  page_loading: "Cargando registros de auditoría...",

  filters_heading: "Filtros",
  filters_label_flujo: "Flujo",
  filters_label_accion: "Acción",
  filters_label_date_start: "Fecha de Inicio",
  filters_label_date_end: "Fecha de Fin",
  filters_placeholder_flujo: "Seleccionar flujo",
  filters_placeholder_accion: "Seleccionar acción",
  filters_label_search: "Buscar por referencia",
  filters_placeholder_search: "Buscar en registros de auditoría...",
  filters_label_client: "Subclientes",
  filters_placeholder_client: "Buscar subclientes…",
  filters_label_organization: "Clientes",
  filters_placeholder_organization: "Buscar clientes…",
  filters_dropdown_empty: "Sin resultados",
  filters_hint: 'Los filtros se aplicarán en la API al hacer clic en "Aplicar Filtros"',
  filters_button_apply: "Aplicar Filtros",
  filters_button_clear: "Limpiar Filtros",
  filters_label_amount_min: "Monto mínimo",
  filters_label_amount_max: "Monto máximo",
  filters_placeholder_amount_min: "ej. 0",
  filters_placeholder_amount_max: "ej. 1000000",

  filter_flujo_note: "Nota",
  filter_flujo_payment_confirmation: "Confirmación de pago",
  filter_flujo_payment: "Pago",
  filter_flujo_shipping_quote: "Cotización de envío",
  filter_flujo_public_account: "Cuenta pública",

  flujo_pago: "Pago",
  flujo_confirmacion: "Confirmación",
  flujo_nota: "Notas",

  accion_cambio_estado: "Cambio de estado",
  accion_actualizacion_datos: "Actualización de datos",
  accion_creacion: "Creación",
  accion_eliminacion: "Eliminación",

  table_showing_one: "Mostrando 1 registro en esta página (Total: {{total}})",
  table_showing_many: "Mostrando {{count}} registros en esta página (Total: {{total}})",
  table_show_label: "Mostrar:",
  table_th_date: "Fecha",
  table_th_reference_code: "Código de referencia",
  table_th_flujo: "Flujo",
  table_th_client: "Cliente",
  table_th_currency: "Moneda",
  table_th_amount: "Monto",
  table_th_accion: "Acción",
  table_th_estado: "Estado",
  table_estado_filed: "COMPLETED",
  table_th_created_by: "Creado por",
  table_th_taken_by: "Tomado por",
  table_th_archivos: "Archivos",
  table_th_actions: "Acciones",
  table_empty: "No hay registros para mostrar.",
  table_button_view_history: "Ver historial",
  table_tooltip_view_archivos: "Ver archivos",

  pagination_records: "Registros del {{from}} al {{to}} de {{total}}",
  pagination_total_pages: "Total de páginas ({{lastPage}})",
  pagination_first_page: "Primera página",
  pagination_prev_page: "Página anterior",
  pagination_next_page: "Página siguiente",
  pagination_last_page: "Última página",

  modal_title: "Historial de la entidad",
  modal_close_aria: "Cerrar",
  modal_loading: "Cargando historial…",
  modal_error_load: "No se pudo cargar el historial.",
  modal_empty: "No hay registros en el historial.",
  modal_section_title: "Historial de cambios",
  modal_duration: "Duración",
  modal_initial_status: "Estado inicial",
  modal_current_status: "Estado actual",
  modal_previous_status: "Estado anterior",
  modal_close_button: "Cerrar",

  modal_action_create: "Creación",
  modal_action_update: "Actualización de datos",
  modal_action_delete: "Eliminación",
  modal_action_status_change: "Cambio de estado",
  modal_action_restore: "Restauración",
  modal_action_view: "Visualización",
  modal_action_take: "Tomado",
  modal_action_release: "Liberado",

  modal_status_pending: "Pendiente",
  modal_status_in_progress: "En proceso",
  modal_status_paid: "Pagado",
  modal_status_confirmed: "Confirmado",
  modal_status_cancelled: "Cancelado",
  modal_status_archived: "Archivado",
  modal_status_filed: "Archivado (filed)",

  modal_archivos_no_comprobantes_note: "Visualización de comprobantes próximamente",
  modal_archivos_no_comprobantes_payment_creation: "Por el momento no hay comprobantes para visualizar.",
  modal_archivos_no_comprobantes_default: "No hay comprobantes para mostrar",
  modal_archivos_deletion_note_label: "Motivo de cancelación",
  modal_archivos_confirmation_source_label: "Ingreso de banco",
  modal_archivos_payment_source_label: "Salida de Banco",

  tab_audit_general: "Solicitudes de confirmaciones de pagos",
  tab_payments: "Solicitudes de pagos",

  payments_loading: "Cargando registros de pagos...",
  payments_filters_heading: "Filtros de Solicitudes de Pagos",
  payments_filters_label_org_name: "Nombre de cliente",
  payments_filters_placeholder_org_name: "ej. Empresa ABC",
  payments_filters_label_client_name: "Nombre de subcliente",
  payments_filters_placeholder_client_name: "ej. Juan Pérez",
  payments_filters_hint: 'Los filtros se aplicarán en la API al hacer clic en "Aplicar Filtros"',
  payments_table_empty: "No hay registros de pagos para mostrar.",
  payments_table_th_client: "Cliente",
  payments_table_th_subclient: "Subcliente",
  payments_table_showing_one: "Mostrando 1 registro en esta página (Total: {{total}})",
  payments_table_showing_many: "Mostrando {{count}} registros en esta página (Total: {{total}})",
  payments_filters_type_to_search: "Escribe para buscar...",
  payments_filters_label_payment_source: "Salida de Banco",
  payments_filters_placeholder_payment_source: "Seleccionar salida de banco",
  filters_label_confirmation_source: "Ingreso de Banco",
  filters_placeholder_confirmation_source: "Seleccionar ingreso de banco",

  tab_verification: "Solicitudes de verificación",
  verification_filters_heading: "Buscar solicitudes de verificación",
  verification_label_org_email: "Email de cliente",
  verification_placeholder_org_email: "ej. cliente@empresa.com",
  verification_label_client_email: "Email de subcliente",
  verification_placeholder_client_email: "ej. subcliente@correo.com",
  verification_filters_hint:
    "Ingrese un email para realizar la búsqueda. Solo se puede buscar por un campo a la vez",
  verification_loading: "Buscando solicitudes de verificación...",
  verification_results_title: "URLs de verificación encontradas",
  verification_type_organization: "Cliente",
  verification_type_client: "Subcliente",
  verification_empty: "No se encontraron URLs de verificación para los criterios ingresados.",
  verification_btn_copy: "Copiar",
  verification_status_active: "Activo",
  verification_status_used: "Usado",
  verification_status_expired: "Expirado",
  verification_error_org_not_found: "No se encontró ningún cliente con el email ingresado",
  verification_error_client_not_found: "No se encontró ningún subcliente con el email ingresado",
};
